export interface InternalLinkProps {
  link: string;
  siteDomain: string;
  blocklist?: string[];
}
const DEFAULT_BLOCKLIST = ['documents', 'users?', 'blog'];

const getInternalLink = ({
  link,
  siteDomain,
  blocklist
}: InternalLinkProps) => {
  /*
    The following regex does the following:
      1. Matches if the url starts with `/pages/`
      2. Matches if the url starts with `http://www.lucidchart.com/pages`
        or `https://www.lucidchart.com/pages/`
        or `www.lucidchart.com/pages/`
        or `http://lucidchart.com/pages/`
        or `https://lucidchart.com/pages/`
      3. Matches if the url starts with `/`
        but doesn't start with `/blog`
        and `/documents`
        and `/users`
        and `/es/users/`
        (?:users?|blog|documents)
  */
  const blocklists = blocklist && !!blocklist.length
    ? [...DEFAULT_BLOCKLIST, ...blocklist]
    : DEFAULT_BLOCKLIST;
  const blocklistRegex = blocklists
    ? `${blocklists.join('|')}`
    : '';
  // const pathPrefixRegex = pathPrefix && pathPrefix !== '/' ? `${pathPrefix}/?|` : '';
  /*
  * ^ # starts at the beginning of the string
  * (?: # non-capturing group
  *   (?:https?://)? # checks for zero or one http(s) protocol
  *   (?:www.)? # checks for zero or one www.
  *   (?:${siteDomain}) # checks for the siteDomain i.e lucidchart.com
  *   (?: # non-capturing group
  *     (?:/pages)?|(?:/)? # checks for zero or one of /pages or zero or one of /
  *   )? # checks for zero or one of the non-capturing group
  *   |(?:/pages)|(?:/) # or checks for /pages or /
  * )
  * (?!/? # negative lookahead checking for a / followed by translation strings
  *   (?:
  *     (?:[a-zA-Z]{2}-)? # zero or one of two letters and a hyphen es-
  *       [a-zA-Z]{2}/? # looks for 2 letters
  *   )?
  *   (?:${blocklistRegex}) # the words to be excluded
  * )(.*)
  */
  const hybridRegex = new RegExp(
    `^(?:(?:https?://)?(?:www.)?(?:${siteDomain})(?:(?:/pages)?|(?:/)?)?|(?:/pages)|(?:/))(?!/?(?:(?:[a-zA-Z]{2}-)?[a-zA-Z]{2}/?)?(?:${blocklistRegex}))(.*)`, 'gi'
  );

  // ^(?:(?:https?:\/\/)?(?:www.)?(?:lucid-test.com)(?:(?:\/pages)?|(?:\/)?)?|(?:\/pages)|(?:\/))(?!\/?(?:(?:[a-zA-Z]{2}-)?[a-zA-Z]{2}\/?)?(?:documents|users?|blog))(.*)
  const checkResult = hybridRegex.exec(link);
  const result = checkResult
    ? checkResult[0] === '/' && !checkResult[1]
      ? '/'
      : checkResult[1].startsWith('/')
        ? checkResult[1]
        : `/${checkResult[1]}`
    : null;

  return result;
};

export default getInternalLink;
